<script lang="ts">
	import ManageSubscription from './ManageSubscription.svelte';

	export let email: string;
</script>

<div class="flex flex-row justify-center items-center">
	<div class="w-[22rem] p-8 text-zinc-300 text-sm border rounded border-zinc-800 bg-zinc-900">
		You are on the legacy Early Adopter plan which costs $27/mo and gives unlimited credits and
		access to all tools.
		<div class="h-6"></div>
		<ManageSubscription {email} />
	</div>
	<div class="hidden lg:flex lg:flex-row">
		<div class="w-3"></div>
		<div class="w-[22rem]"></div>
	</div>
	<div class="hidden lg:flex lg:flex-row">
		<div class="w-3"></div>
		<div class="w-[22rem]"></div>
	</div>
</div>
